import { useGet } from './useFetch'
import { useAuth } from './useAuth'

interface ClinicGroupUserRolePermission {
  clinic_group_user_role_permission_id: number
  user_role_id: number
  module: string
  allowed_action: string[]
  created_at: string
  updated_at: string
}

interface ClinicGroupUserRolePermissionListResponse {
  success: boolean
  data: ClinicGroupUserRolePermission[]
  error?: {
    code: string
    message: string
  }
}

export function useClinicGroupUserRolePermissionByRoleId(roleId: number, enabled: boolean = true) {
  const { token } = useAuth()

  const { data, error, isLoading, mutate } = useGet<ClinicGroupUserRolePermissionListResponse>(
    token && enabled ? `/api/clinic-group-user-role-permissions/role/${roleId}` : null,
    undefined,
    token ?? '',
    undefined,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      refreshInterval: 0,
      shouldRetryOnError: false,
    },
  )

  return {
    permissions: data?.data ?? [],
    isLoading: enabled ? isLoading : false,
    isError: enabled ? error : null,
    mutate,
  }
}
